import React from 'react'

import styled from '@emotion/styled'
import { mq, text, green01, grayBorder, black03 } from '../../../_style';
import Text from '../../atoms/text';
import Image from '../../atoms/image';

const Container = styled.div`
  & + & {
    margin-top: 60px;
    ${mq.sp} {
      margin-top: 45px;
    }
  }
`
const TitleContainer = styled.div`
  h5 {
    color: ${black03};
    position: relative;
    padding-left: 12px;
    font-weight: bold;
    ${text('18px', 32 / 18)}
    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 7px;
      bottom: 7px;
      width: 5px;
      margin: auto;
      background-color: ${green01};
    }
  }
`
const TextArea = styled.div`
  & > div {
    & + p {
      padding-top: 20px;
    }
  }
`
const ImgContainer = styled.div`
  margin-top: 30px;
  ${props => props.isImgBorder && `border: 1px solid ${grayBorder}`};
  ${mq.pc} {
    max-width: 304px;
  }
`
export default class DetailFeatureBox extends React.Component {
  render() {
    return(
      <Container>
        <TextArea>
          {this.props.title && <TitleContainer><h5>{this.props.title}</h5></TitleContainer>}
          {this.props.children && <Text>{this.props.children}</Text>}
        </TextArea>
        {this.props.img &&
          <ImgContainer isImgBorder={this.props.isImgBorder}>
            <Image filename={this.props.img} alt={this.props.alt}></Image>
          </ImgContainer>
        }
      </Container>
    )
  }
}
